export enum CustomPerformanceDataViewType {
    TOTAL_PERFORMANCE = 27,
    PERIOD_VIEW = 30,
    POPULATION_VIEW = 31,
}
